import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lebanonMOConfig } from "./data";

export default function LebanonMOPage() {
  return <CityPageTemplate config={lebanonMOConfig} />;
}